var render = function render(){
  var _vm$card, _vm$global$profile;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return (_vm.source.card || _vm.source.id) && _vm.tabKey ? _c('dialog-scroll-lock', _vm._g(_vm._b({
    attrs: {
      "width": "800",
      "scrollable": "",
      "value": true,
      "content-class": `white fill-height overflow-x-hidden ${_vm.selected ? 'no-touch-action' : ''}`
    },
    on: {
      "input": function ($event) {
        return _vm.$router.push({
          hash: undefined
        });
      }
    }
  }, 'dialog-scroll-lock', _vm.$attrs, false), _vm.$listeners), [_c('error-dialog', {
    attrs: {
      "status": _vm.sendSampleStatus
    }
  }), _vm.showGiftcardBlob ? [_vm.showGiftcardBlob.user_id == _vm.card.user_id ? _c('giftcard-add-dialog', {
    attrs: {
      "blob": _vm.showGiftcardBlob
    },
    on: {
      "input": function ($event) {
        _vm.showGiftcardBlob = null;
      }
    }
  }) : _c('giftcard-edit-dialog', {
    attrs: {
      "order": _vm.card,
      "blob": _vm.showGiftcardBlob,
      "max-giftcard-value": 5000,
      "max-giftcard-value-remaining": 5000
    },
    on: {
      "input": function ($event) {
        _vm.showGiftcardBlob = null;
      }
    }
  })] : _vm._e(), _vm.showEvent ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "600"
    },
    model: {
      value: _vm.showEvent,
      callback: function ($$v) {
        _vm.showEvent = $$v;
      },
      expression: "showEvent"
    }
  }, [_c('v-card', [_c('div', [_c('order-stepper-event', {
    staticClass: "relative mt-n2",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "hide-preview": true,
      "order-id": null,
      "order": _vm.card,
      "contributors": {
        isSent: false,
        nOther: 0,
        deliveriesByTarget: {},
        uninvited: []
      },
      "deliveries": {
        byTarget: {}
      },
      "responses": {
        list: [],
        byKey: {}
      }
    }
  })], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    on: {
      "click": function ($event) {
        _vm.showEvent = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1) : _vm._e(), _vm.showSend ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "300"
    },
    model: {
      value: _vm.showSend,
      callback: function ($$v) {
        _vm.showSend = $$v;
      },
      expression: "showSend"
    }
  }, [_vm.showCaptcha ? _c('captcha-overlay', {
    on: {
      "cancel": function ($event) {
        _vm.showCaptcha = false;
      },
      "complete": _vm.sendSample
    }
  }) : _vm._e(), _c('v-card', [_c('v-card-title', [_vm._v("Send yourself a sample")]), _c('v-card-text', [_c('v-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        _vm.showCaptcha = true;
      }
    },
    model: {
      value: _vm.isEmailValid,
      callback: function ($$v) {
        _vm.isEmailValid = $$v;
      },
      expression: "isEmailValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email-address",
      "label": "Your email address",
      "persistent-placeholder": "",
      "hide-details": "",
      "rules": [function (v) {
        return !!(v && _vm.EMAIL_REGEX.test(v));
      }]
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1)], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.sendSampleStatus.pending
    },
    on: {
      "click": function ($event) {
        _vm.showSend = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.isEmailValid || !_vm.isFormValid,
      "loading": _vm.sendSampleStatus.pending
    },
    on: {
      "click": function ($event) {
        _vm.showCaptcha = true;
      }
    }
  }, [_vm._v(" Submit ")])], 1)], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "relative d-flex flex-column",
    style: {
      'background-color': (_vm$card = _vm.card) === null || _vm$card === void 0 ? void 0 : _vm$card.skin.page_background_color
    }
  }, [_vm.card ? _c('card-background', {
    attrs: {
      "src": _vm.card.skin.page_background_img
    }
  }) : _vm._e(), _vm.card && _vm.card.skin.open_effect ? _c('confetti', {
    key: _vm.card.skin.open_effect,
    staticClass: "absolute-fill overflow-hidden",
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "effect": _vm.card.skin.open_effect,
      "active": true
    }
  }) : _vm._e(), _c('div', {
    staticClass: "relative",
    staticStyle: {
      "z-index": "3"
    }
  }, [_c('div', {
    staticClass: "pa-4 d-flex",
    staticStyle: {
      "backdrop-filter": "blur(16px)",
      "-webpack-backdrop-filter": "blur(16px)",
      "background-color": "#0002"
    }
  }, [_c('div', {
    staticClass: "flex-grow-1 header-font text-h4 white--text font-weight-bold",
    staticStyle: {
      "text-shadow": "1px 1px 3px #000A"
    }
  }, [_c('span', {
    staticClass: "hidden-sm-and-up"
  }, [_vm._v("Demo")]), _c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("Try our editing tools")])]), (_vm$global$profile = _vm.global.profile) !== null && _vm$global$profile !== void 0 && _vm$global$profile.admin && _vm.source.id ? _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "exact": "",
      "small": "",
      "fab": "",
      "to": {
        name: 'admin-order',
        params: {
          token: _vm.source.id
        }
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiOpenInNew)
    }
  })], 1) : _vm._e(), _c('v-fade-transition', [_vm.tabI ? _c('div', {
    staticClass: "relative mr-3"
  }, [_c('v-btn', {
    staticClass: "px-2 px-md-3 elevation-6",
    staticStyle: {
      "height": "40px",
      "right": "100%",
      "min-width": "unset"
    },
    attrs: {
      "absolute": "",
      "exact": "",
      "rounded": "",
      "to": _vm.getRoute(_vm.tabs[_vm.tabI - 1].key)
    }
  }, [_c('v-icon', {
    staticClass: "ml-md-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronLeft)
    }
  }), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v("Back")])], 1)], 1) : _vm._e()]), _c('v-btn', _vm._b({
    staticClass: "mr-3 elevation-6 pulse",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "color": "primary",
      "exact": "",
      "rounded": ""
    },
    on: {
      "!click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return function () {
          if (_vm.tabI == _vm.tabs.length - 1) _vm.showSend = true;else _vm.$router.push(_vm.getRoute(_vm.tabs[_vm.tabI + 1].key));
        }.apply(null, arguments);
      }
    }
  }, 'v-btn', _vm.tabI == _vm.tabs.length - 1 ? {} : {
    to: _vm.getRoute(_vm.tabs[_vm.tabI + 1].key)
  }, false), [_vm._v(" Next "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    attrs: {
      "exact": "",
      "small": "",
      "fab": "",
      "to": {
        hash: undefined
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1)], 1)]), !_vm.card ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "flex-grow-1 relative",
    staticStyle: {
      "z-index": "3"
    }
  }, [_c('div', {
    staticClass: "absolute-fill",
    staticStyle: {
      "z-index": "1",
      "transition": "opacity .12s"
    },
    style: {
      opacity: _vm.tabs[_vm.tabI].key == 'sign' ? 1 : 0
    }
  }, [_c('card-editor', {
    ref: "sample-editor",
    attrs: {
      "mode": "edit",
      "is-owner": "",
      "show-event-details": "",
      "card": _vm.card
    },
    on: {
      "loaded-cover": _vm.onLoadedCover,
      "select-blob": function (x) {
        return _vm.selected = x;
      },
      "click-giftcard": function (x) {
        return _vm.showGiftcardBlob = x;
      },
      "insert-blob": function (_, x) {
        return x.sample = true;
      },
      "step-to": function (v) {
        return _vm.showEvent = v == 'event';
      },
      "click-event-details": function ($event) {
        _vm.showEvent = true;
      }
    }
  })], 1), _c('v-slide-x-transition', [_vm.tabs[_vm.tabI].key == 'theme' ? _c('div', {
    staticClass: "fill-height relative",
    staticStyle: {
      "z-index": "2"
    }
  }, [_c('order-stepper-theme', {
    staticClass: "fill-height",
    staticStyle: {
      "min-height": "446px",
      "z-index": "2"
    },
    attrs: {
      "order": _vm.card,
      "org-skin": _vm.NO_LOGO_SKIN,
      "hide-background-confetti": true
    },
    on: {
      "input": function (v) {
        return Object.assign(_vm.card, v);
      }
    }
  })], 1) : _vm._e()])], 1)], 1)], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }